module.exports = __webpack_public_path__ + "media/ringtone.f845b2d3.mp3";